import { LocationAttributesWithId } from '../model/order.model'

/**
 * LocationAttributesWithId to Location
 */

export const transformLocationAttributesWithId = (
  locationAttributes: LocationAttributesWithId,
) => ({
  ...locationAttributes,
})

export type Location = ReturnType<typeof transformLocationAttributesWithId>
